import api from '../../api'
import {
  GET_MATERIAL_LIST_SUCCESS,
  GET_MATERIAL_LIST_FAILURE,
  GET_MATERIAL_FAILURE,
  GET_MATERIAL_SUCCESS,
  UPDATE_MATERIAL_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getMaterialList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getMaterialList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_MATERIAL_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_MATERIAL_LIST_SUCCESS, {
        materialList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_MATERIAL_LIST_FAILURE)
      return reject(response.body.$error)
    })
  })

  },
 
  cleanMaterialList({commit}) {
    return commit(GET_MATERIAL_LIST_FAILURE)
  },
  getMaterial({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getMaterial(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_MATERIAL_FAILURE);
            reject();
          }
          commit(GET_MATERIAL_SUCCESS, {
            material: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_MATERIAL_FAILURE);
          reject();
        })
    })
  },
 
  
  updateMaterial({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
        "density",
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateMaterial(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },


  createMaterial({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createMaterial(data)
      .then(response => {
        if (!response.ok) {
          api.stopLoader()
          return reject(response.body.$error);
        } else {
          api.stopLoader()
          return resolve(response.body.$success);
        }
      }, response => {
        api.stopLoader()
        return reject(response.body.$error);
      })
    })
  },
  
  
 
  deleteMaterial({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteMaterial(data)
         .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
    })
  },

  
  
};

const mutations = {

  [UPDATE_MATERIAL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.material));
  },
  [GET_MATERIAL_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_MATERIAL_LIST_SUCCESS](state, action) {
    state.list = action.materialList;
    state.listUpdated = new Date();
  },
  [GET_MATERIAL_FAILURE](state) {
    state.selected = null
  },
  [GET_MATERIAL_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.material));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/material.js